import { Pipe, PipeTransform } from '@angular/core';
import { Many, orderBy } from 'lodash';

export type SortOrder = 'asc' | 'desc';

@Pipe({
	name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {
	transform(
		value: any[],
		sortKey: string | string = 'id',
		sortOrder: SortOrder | string = 'asc',
		optionnalSortKeys?: string[],
		optionnalSortOrder?: string[]
	): any {
		sortOrder = sortOrder && (sortOrder.toLowerCase() as any);

		if (
			!value ||
			value.length === 0 ||
			(sortOrder !== 'asc' && sortOrder !== 'desc')
		) {
			return value;
		}

		if (value.length === 1) {
			return value;
		}

		if (optionnalSortKeys && optionnalSortKeys.length > 0) {
			optionnalSortKeys.unshift(sortKey);
			if (optionnalSortOrder && optionnalSortOrder.length > 0) {
				optionnalSortOrder.unshift(sortOrder);
				return orderBy(
					value,
					optionnalSortKeys,
					optionnalSortOrder.filter((c) => c === 'asc' || c === 'desc') as Many<
						boolean | 'asc' | 'desc'
					>
				);
			}
			return orderBy(value, optionnalSortKeys, [sortOrder]);
		}

		return orderBy(value, [sortKey], [sortOrder]);
	}
}
